import {noop} from 'lodash'
import {createLogger} from 'logging'


const logger = createLogger('userTrackingService')

const trackEventByParams = ({category, action, label, value, extraData, ga4EventName}) => {
  const trackEventByParams = window.trackEventByParams || window.parent.trackEventByParams
  if (process.env.NODE_ENV === 'production' && !trackEventByParams) {
    logger.error(new Error('window.trackEventByParams is missing in production.'))
  }
  const trackingFunc = trackEventByParams || noop
  return trackingFunc(category, action, label, value, extraData, ga4EventName)
}

export default {
  report(eventObj) {
    trackEventByParams(eventObj)
  },

  logError: logger.error,

  trackEventByParams(category, action, label, value, ga4EventName) {
    trackEventByParams({category, action, label, value, ga4EventName})
  }

}
